<script>
  // Define the URLs for the images and their corresponding links
  const imageLinks = [
    { src: '../images/logos/ApplePodcasts.svg', url: 'https://itunes.apple.com/us/podcast/freedom-writers-podcast/id1368157992', title: 'Apple Podcasts' },
    { src: '../images/logos/Spotify.svg', url: 'https://open.spotify.com/show/3vXO7hdqhpOexB1gyCCe90', title: 'Spotify' },
    { src: '../images/logos/GooglePodcasts.svg', url: 'https://podcasts.google.com/feed/aHR0cDovL2ZlZWRzLnNvdW5kY2xvdWQuY29tL3VzZXJzL3NvdW5kY2xvdWQ6dXNlcnM6NDI0ODEwNzg4L3NvdW5kcy5yc3M', title: 'Google Podcasts' },
    { src: '../images/logos/PandoraPodcasts.svg', url: 'https://www.pandora.com/podcast/freedom-writers-podcast/PC:30606', title: 'Pandora' },
  ];
</script>

<style>
  .image-container {
    margin: 3.4rem 0 3.4rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 2%; /* Adjust the gap to ensure the images and gaps sum to 100% width */
  }
  .image-container img {
    width: 14vw; /* 14% of the view width */
    cursor: pointer;
  }
  @media (max-width: 768px) {
    .image-container {
    margin: 1rem 0 1rem 0;
      justify-content: space-around;
    }
    .image-container img {
      padding: 14px 0 14px 0;
      width: 34vw; /* 34% of the view width on mobile */
    }
  }
</style>

<div class="image-container">
  {#each imageLinks as { src, url, title }}
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img src={src} alt="{title} Logo">
    </a>
  {/each}
</div>